import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement(
    'title',
    null,
    'Trace Icons_1-3'
  ),
  React.createElement('path', { d: 'M12.62,29.78v-12L5.08,5a1.78,1.78,0,0,1,0-1.65,1.56,1.56,0,0,1,1.36-.85H25.57a1.56,1.56,0,0,1,1.36.85,1.76,1.76,0,0,1,0,1.61l-7.56,12.8v9.28ZM6.43,3.83A.25.25,0,0,0,6.22,4a.48.48,0,0,0,0,.42l7.7,13V27.86l4.16-1.67V17.44L25.8,4.37a.46.46,0,0,0,0-.38.25.25,0,0,0-.21-.16Z' })
));